<template>
  <div>
    <assign-to-class
      :dialogVisible="modals.showAssignToClass"
      :selectedAssignment="selectedAssignmentToAssign"
      v-on:closed="handleLeaveAssignment"
      v-on:done="handleAssignToClassSuccess"
      ref="assignToClass"
    />
    <leave-create-assignment-modal
      :dialogVisible="modals.showLeaveAssignment"
      append-to-body
      v-on:closed="modals.showLeaveAssignment = false"
      v-on:leave="handleConfirmLeaveAssignment"
    />
    <assign-to-class-success-modal
      :createdAssignments="createdAssignments"
      :page="2"
      :dialogVisible="modals.showAssignToClassSuccess"
      append-to-body
      v-on:closed="handleReviewAssignmentSuccess"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AssignToClass from "@/components/modals/homeworks/AssignToClass";
import LeaveCreateAssignmentModal from "@/components/modals/homeworks/LeaveCreateAssignment";
import AssignToClassSuccessModal from "@/components/modals/studysets/AssignToClassSuccessModal";

export default {
  components: {
    AssignToClass,
    LeaveCreateAssignmentModal,
    AssignToClassSuccessModal,
  },
  data() {
    return {
      modals: {
        showAssignToClass: false,
        showLeaveAssignment: false,
        showAssignToClassSuccess: false,
      },
      deleteStudySetId: -1,
      selectedAssignmentToAssign: null,
    };
  },
  computed: {
    organizationId() {
      return this.$store.state.organization.currentOrganizationId;
    },
    organizationData() {
      return this.$store.state.organization.currentOrganization;
    },
    ...mapGetters("organization", ["isOrganizationAdmin", "isOrganizationAssociateAdmin", "currentOrganizationType"]),
    ...mapGetters({
      createdAssignments: "homeworks/getCreatedAssignments",
    }),
  },
  methods: {
    ...mapActions({
      deleteStudySetAction: "studysets/deleteStudySet",
    }),
    handleLeaveAssignment() {
      if (this.$refs.assignToClass.emptyCheck() == 1) this.modals.showLeaveAssignment = true;
      else this.modals.showAssignToClass = false;
    },
    handleConfirmLeaveAssignment() {
      this.$refs.assignToClass.reset();
      this.modals.showAssignToClass = false;
      this.modals.showLeaveAssignment = false;
    },
    handleAssignToClassSuccess() {
      this.$refs.assignToClass.reset();
      this.modals.showAssignToClass = false;
      this.modals.showLeaveAssignment = false;
      this.modals.showAssignToClassSuccess = true;
    },
    handleReviewAssignmentSuccess() {
      this.modals.showAssignToClassSuccess = false;
      this.$emit("reload");
    },
    handleAssignToClass(assignment) {
      this.selectedAssignmentToAssign = assignment;
      this.$refs.assignToClass.showAssignmentName(assignment.name);
      this.modals.showAssignToClass = true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
